import React, { useState } from "react";
import cn from "classnames";
import styles from "./Balance.module.sass";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import finance from "../../../i11/Finance";

import Sybmols from "../Currencies.json";
import { useUser } from "../../../context";

const HeaderBalance = ({ className, balance }) => {
	const { locale } = useUser();

	const [select, setSelect] = useState(0);
	const availableList = balance?.available || [];
	const pendingList = balance?.pending || [];
	const connectReserved = balance?.connect_reserved || [];

	const selectSymbol =
		Sybmols[availableList[select]?.currency.toUpperCase()]?.symbol || {};
	const totalAmount =
		(availableList[select]?.amount +
			connectReserved[select]?.amount +
			pendingList[select]?.amount) /
		100;

	return (
		<>
			<Card className={cn(styles.card, className)}>
				<div className={styles.overview}>
					<div className={styles.list}>
						{/* {items.map((x, index) => (
							<div className={styles.item} key={index}>
								<div
									className={styles.icon}
									style={{ backgroundColor: x.color }}
								>
									<Icon name={x.icon} size="24" />
								</div>
								<div className={styles.details}>
									<div className={styles.label}>{x.title}</div>
									<div className={styles.counter}>{x.counter}</div>
								</div>
							</div>
						))} */}
						{availableList.map((el, index) => (
							<div
								onClick={() => setSelect(index)}
								className={cn(
									styles.item,
									index === select ? styles.selected : ""
								)}
								key={index}
							>
								<p>{el.currency.toUpperCase()}</p>
								<h4>
									{Sybmols[el?.currency.toUpperCase()].symbol}{" "}
									{(el?.amount || 0) / 100}
								</h4>
							</div>
						))}
					</div>
					{availableList && availableList.length > 0 && (
						<div className={styles.detail}>
							<p className={styles.balance}>
								{availableList[select]?.currency.toUpperCase()}{" "}
								{finance[locale].balance}
							</p>
							<div className={styles.divider} />

							<div className={styles.flex}>
								<p>{finance[locale].available_sub_title}</p>
								<h4>
									{selectSymbol}{" "}
									{(availableList[select]?.amount || 0) / 100}
								</h4>
							</div>

							<div className={styles.flex}>
								<p>{finance[locale].connect_reserved_sub}</p>
								<h4>
									{selectSymbol}{" "}
									{(connectReserved[select]?.amount || 0) /
										100}
								</h4>
							</div>

							<div className={styles.flex}>
								<p>{finance[locale].pending_sub}</p>
								<h4>
									{selectSymbol}{" "}
									{(pendingList[select]?.amount || 0) / 100}
								</h4>
							</div>
							<div className={styles.divider} />
							<div className={styles.flex}>
								<p>{finance[locale].total}</p>
								<h4>
									{selectSymbol} {totalAmount}
								</h4>
							</div>
						</div>
					)}
					{/* {pendingList.map((el, index) => (
						<div onClick={() => setSelect(index)} key={index}>
							<p>{el.currency.toUpperCase()}</p>
							<h4>
								{Sybmols[el?.currency.toUpperCase()].symbol}{" "}
								{el.amount}
							</h4>
						</div>
					))} */}
				</div>
			</Card>
		</>
	);
};

export default HeaderBalance;
